import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {ErmRegMainResource} from "../../../../service/ErmRegMainResource";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {ErmRegMainDto} from "../../../../../generated-model/model";

export const ermRegMainConsiderServiceResolver: ResolveFn<ErmRegMainDto> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: ErmRegMainResource = inject(ErmRegMainResource),
): Observable<ErmRegMainDto> => {
  return service.findConsider(+route.paramMap.get('id'));
};
